import './style.scss'
import Layer from '../../../../../../Shared/Layer'
import Button from '../../../../../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import { PropTypes } from 'prop-types'
import { BUTTON_MIN_WIDTH } from '../../../../../Form/Button/constants'

const ErroneousFactsNoticeOverlay = ({ onHide, factLabels = [] }) => {
  const { t } = useTranslation()
  return (
    <Layer
      disallowHiding={false}
      type="center"
      size="small"
      id={'delete-confirmation'}
      show={true}
      onHideClick={onHide}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="erroneous-facts-notice-overlay"
      closeOnEsc={true}
    >
      <div className="erroneous-facts-notice-overlay__header">
        {t('editProperty.factsheet.erroneousFactsNoticeOverlay.title')}
      </div>
      <div className="erroneous-facts-notice-overlay__description">
        <ul>
          {factLabels.map((label, index) => (
            <li key={index}>{label}</li>
          ))}
        </ul>
      </div>
      <div className={'erroneous-facts-notice-overlay__buttons'}>
        <Button
          align={'center'}
          onClick={onHide}
          minWidth={BUTTON_MIN_WIDTH}
        >
          {t('BUTTON_OK')}
        </Button>
      </div>
    </Layer>
  )
}

ErroneousFactsNoticeOverlay.propTypes = {
  onHide: PropTypes.func.isRequired,
}

export default ErroneousFactsNoticeOverlay
